import { get, post, remove } from 'src/tools/server';
export const getTags = () => {
  return get<any>('/portal/setting/tagManager', {});
};

export const getProductTags = () => {
  return get<any>('/portal/setting/tagManager/productTag/list', {});
};

export const saveProductTag = (body) => {
  return post<any>('/portal/setting/tagManager/productTag', body, {});
};

export const deleteProductTag = (uuid) => {
  return remove<any>(`/portal/setting/tagManager/productTag/${uuid}`, {});
};

export const saveFileTag = (body) => {
  return post<any>('/portal/setting/tagManager/fileTag', body, {});
};

export const deleteFileTag = (uuid) => {
  return remove<any>(`/portal/setting/tagManager/fileTag/${uuid}`, {});
};

export const getFileTags = () => {
  return get<any>('/portal/setting/tagManager/fileTag/list', {});
};
